import request from '../services/request';

export function getIdentityInformation() {
  return request({
    url: '/identity',
    method: 'GET',
  });
}
